module.exports = __webpack_public_path__ + "img/desc_bottom_kg4002.1ea8523f.png";